import React from "react";
import PropTypes from "prop-types";
import VerifiedIcon from '../../assets/icons/verified.svg'

const CompanyValidation = ({value, formData}) => {

  return (
    <div className="form-component-company-validation">
      {value === true ?
        <div className="badge">
          <img src={VerifiedIcon} alt="Verified Icon" width="40px" />
          <div className="label">Geverifieerd</div>
        </div>
        :
        <span>
          {formData.model.type === 'commercial' && 'Dit bedrijf is nog niet geverifieerd'}
          {formData.model.type === 'non-official' && '"Niet officiële" accounts kunnen niet geverifieerd worden. Kies een ander "type account" als je geverifieerd wil zijn.'}
          {formData.model.type === 'public' && 'Deze organisatie is nog niet geverifieerd'}
          {formData.model.type === 'non-profit' && 'Deze non-profit is nog niet geverifieerd'}
        </span>
      }
    </div>
  );
};

CompanyValidation.propTypes = {
  name: PropTypes.string.isRequired,
};

export default CompanyValidation;
